import { Col, Row, Space, Typography } from 'antd';
import Compact from 'antd/es/space/Compact';
import DragUpload from '@Components/BasicComponents/DragUpload';
import InfoTooltip from './InfoTooltip';
import { useMemo } from 'react';

const {Text} = Typography;

const BulkUpload = ({
	handleUpload,
	handleRemove,
	value,
	accept,
	beforeUpload,
	error = {isOk: true},
	tooltip,
	title = null,
	required,
	disableRemove = false,
	allowRemoveOnErrorOnly = false,
}) => {

	const classNames = useMemo(() => {
		const res = ['bulk-upload__row'];

		if (allowRemoveOnErrorOnly) {
			res.push('bulk-upload__row__error-remove-only');
		} else if (disableRemove && !allowRemoveOnErrorOnly) {
			res.push('bulk-upload__row__disabled-remove');
		}

		return res.join(' ');

	}, [allowRemoveOnErrorOnly, disableRemove]);

	return (
		<Compact block size="middle" direction='vertical'>
			<Row  align="middle" gap={10}>
				<Space>
					<h3>
						{title || 'Files upload'}
						{required && '*'}
					</h3>
					{tooltip && <InfoTooltip text={tooltip} />}
				</Space>
			</Row>
			<DragUpload
				listType="picture"
				value={value}
				className={classNames}
				multiple
				beforeUpload={beforeUpload}
				handleUpload={handleUpload}
				accept={accept}
				onRemove={disableRemove && !allowRemoveOnErrorOnly ? false : handleRemove}
				allowRemoveOnErrorOnly={allowRemoveOnErrorOnly}
				style={!error?.isOk && {borderColor: 'red'}}
			/>
			<Row align="middle">
				<Col span={16}>
					<Text type={error.type === 'error' ? 'danger' : 'warning'}>{error?.text}</Text>
				</Col>
			</Row>
		</Compact>
	);
};

export default BulkUpload;